"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserDeviceMeta = exports.Device = void 0;
const base_models_1 = require("./base-models");
class Device extends base_models_1.VasatModel {
    constructor(vasat, id) {
        super(vasat, 'Device', id);
    }
    toJSON() {
        var dm = this.vasat.deviceMeta();
        var vars = {
            id: this.id || null,
            pushRegId: this.pushRegId,
            allowPush: this.allowPush,
            pushRegIdSent: this.pushRegIdSent,
        };
        Object.keys(vars).forEach(k => dm[k] = vars[k]);
        return dm;
    }
}
exports.Device = Device;
class BrowserDeviceMeta {
    guid() {
        var nav = window.navigator;
        var screen = window.screen;
        var guid = '' + nav.mimeTypes.length;
        guid += nav.userAgent.replace(/\D+/g, '');
        guid += nav.plugins.length;
        guid += ('' + screen.height) || '';
        guid += ('' + screen.width) || '';
        guid += ('' + screen.pixelDepth) || '';
        guid += ('' + Math.random());
        return guid;
    }
    static browserV() {
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        var fullVersion = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;
        // In Opera, the true version is after "Opera" or after "Version"
        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browserName = "Microsoft Internet Explorer";
            fullVersion = nAgt.substring(verOffset + 5);
        }
        // In Chrome, the true version is after "Chrome" 
        else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
            fullVersion = nAgt.substring(verOffset + 7);
        }
        // In Safari, the true version is after "Safari" or after "Version" 
        else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browserName = "Safari";
            fullVersion = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf("Version")) != -1)
                fullVersion = nAgt.substring(verOffset + 8);
        }
        // In Firefox, the true version is after "Firefox" 
        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browserName = "Firefox";
            fullVersion = nAgt.substring(verOffset + 8);
        }
        // In most other browsers, "name/version" is at the end of userAgent 
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browserName = nAgt.substring(nameOffset, verOffset);
            fullVersion = nAgt.substring(verOffset + 1);
            if (browserName.toLowerCase() == browserName.toUpperCase()) {
                browserName = navigator.appName;
            }
        }
        // trim the fullVersion string at semicolon/space if present
        if ((ix = fullVersion.indexOf(";")) != -1)
            fullVersion = fullVersion.substring(0, ix);
        if ((ix = fullVersion.indexOf(" ")) != -1)
            fullVersion = fullVersion.substring(0, ix);
        majorVersion = parseInt('' + fullVersion, 10);
        if (isNaN(majorVersion)) {
            fullVersion = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }
        return {
            browserName: browserName,
            fullVersion: fullVersion,
            majorVersion: majorVersion
        };
    }
    getMeta() {
        var bo = BrowserDeviceMeta.browserV();
        var n = navigator;
        return {
            name: bo.browserName + " - " + bo.fullVersion,
            remoteID: this.guid(),
            deviceType: {
                deviceModel: bo.browserName + ' ' + bo.majorVersion,
                deviceMake: 'Browser',
                deviceOSName: navigator.platform,
                deviceOSVersion: n['oscpu'] || '?'
            }
        };
    }
    static makeBrowserDevice() {
        var bo = this.browserV();
        return {
            osName: navigator.platform,
            deviceType: 'Browser',
            make: bo.browserName,
            osVersion: bo.fullVersion
        };
    }
}
exports.BrowserDeviceMeta = BrowserDeviceMeta;
